import { type HTMLAttributes, type PropsWithChildren, type ReactNode } from 'react';
import Icon from '@common/components/Icon';
import IconSpinner from '@common/components/svgs/common/Spinner';
import classnames from '@common/utils/ui/classnames';

interface SectionLayoutProps extends HTMLAttributes<HTMLDivElement> {
  paddinglessTop?: boolean;
  paddinglessBottom?: boolean;
  showLoadingSpinner?: boolean;
  scrollInside?: boolean;
  /** Decorative layer painted behind the container, covering the whole section edge to edge. */
  background?: ReactNode;
}

function SectionLayout({
  children,
  paddinglessTop,
  paddinglessBottom,
  showLoadingSpinner,
  scrollInside,
  background,
  ...rest
}: PropsWithChildren<SectionLayoutProps>) {
  return (
    <section
      className={classnames({
        'section-content': true,
        'section-content--paddingless-top': paddinglessTop,
        'section-content--paddingless-bottom': paddinglessBottom,
        'section-content--windowed': scrollInside,
        'section-content--with-background': !!background,
        'justify-content-center': showLoadingSpinner,
      })}
      {...rest}
    >
      {background}
      <div
        className={classnames({
          container: true,
          'container--windowed': scrollInside,
        })}
      >
        {showLoadingSpinner
          ? (
            <div className="section-content__loading">
              <Icon component={IconSpinner} size={24} />
            </div>
          )
          : children}
      </div>
    </section>
  );
}

export default SectionLayout;
